var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',_vm._l((_vm.content),function(data,key){return _c('td',{key:key},[_vm._v(" "+_vm._s(data)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }